import { Container } from 'mdbreact'
import LogInForm from '../../components/LogInForm/LogInForm'

const LogInPage = () => {

    return (
        <>
            <Container>

                <LogInForm />

            </Container>
        </>
    )
}

export default LogInPage